export const initialValues = {
  first_name: "",
  middle_name: "",
  aadhar_no: null,
  surname: "",
  maternal_surname: "",
  gender: "Male",
  email: "",
  password: "",
  mobile_number: "",
  birth_date: "",
  blood_group: "",
  education_id: null,
  marital_status: "",
  current_address: "",
  current_district_id: null,
  current_taluka_id: null,
  current_village_id: null,
  other_village_name: "",
  native_address: "",
  native_district: "",
  native_taluka: "",
  native_village: "",
  other_native_village_name: "",
  show_main_number: 1,
  general_occupation_id: null,
  occupation_details: "",
  company_name: "",
  image: "",
  is_head_person: 0,
  is_active: 0,
  parent_id: "",
  relation: "",
  member_number: "",
  expire_verification: "",
  is_verified: 0,
  country_code: "",
};
